import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/layout/Home.vue'),
    meta: {
      title: '首页'
    },
  }, {
    path: "/giftDraw",
    name: "giftDraw",
    component: () => import('@/components/giftDraw.vue'),
    meta: {
      title: "幸运抽奖"
    }
  }, {
    path: "/address",
    name: "address",
    component: () => import('@/components/address.vue'),
    meta: {
      title: "地址填写"
    } 
  }, {
    path: "/addressConfirm",
    name: "addressConfirm",
    component: () => import('@/components/addressConfirm.vue'),
    meta: {
      title: "地址确认"
    }
  }, {
    path: "/activityRule",
    name: "activityRule",
    component: () => import('@/components/activityRule.vue'),
    meta: {
      title: "活动规则"
    }
  }, {
    path: "/myGiftAll",
    name: "myGiftAll",
    component: () => import('@/components/myGiftAll.vue'),
    meta: {
      title: "我的礼品"
    }
  },
  {
    path: "/noActive",
    name: "noActive",
    component: () => import("@/components/noActive.vue")
  },
  {
    path: "/groundMarketingHome",
    name: "groundMarketingHome",
    component: () => import("@/components/theGroundMarketing/groundMarketingHome.vue")
  },
  {
    path: "/groundMarketingGiftList",
    name: "groundMarketingGiftList",
    component: () => import("@/components/theGroundMarketing/groundMarketingGiftList.vue")
  }
];


const router = new VueRouter({
  routes,
  base: process.env.BASE_URL,
});
export default router;
